module.exports = __webpack_public_path__ + "static/img/qq.d07c93d4.svg";